// extracted by mini-css-extract-plugin
module.exports = {"admin-profile-selector":"LoggingProfileSelector--admin-profile-selector","adminProfileSelector":"LoggingProfileSelector--admin-profile-selector"};